import { useState } from 'react';
import styled from 'styled-components';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useTranslation } from 'react-i18next';

const MenuButton = styled(IconButton)``;

export default function HeaderMenu() {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const { t } = useTranslation();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <MenuButton
                id="header-menu-button"
                aria-controls="header-menu"
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <MenuIcon />
            </MenuButton>
            <Menu
                id="header-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'header-menu-button',
                }}
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <MenuItem
                    component="a"
                    href={`mailto:info.kassim@wur.nl?subject=${t(
                        'contact-subject'
                    )}`}
                    onClick={handleClose}
                >
                    {t('menu.Contact')}
                </MenuItem>
                <MenuItem
                    component="a"
                    href="https://www.wur.nl/nl/Privacy-Cookie-verklaring.htm"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={handleClose}
                >
                    {t('menu.Privacy')}
                </MenuItem>
                <MenuItem
                    component="a"
                    href="https://www.wur.nl/nl/Disclaimer-1.htm"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={handleClose}
                >
                    {t('menu.Disclaimer')}
                </MenuItem>
            </Menu>
        </div>
    );
}
